<script>
export default {
  props: ['countSelectValue', 'beginTs', 'time'],
  data () {
    return {
      rfRmsOption: {
        // tooltip: {
        //   trigger: 'axis',
        //   formatter: function (params) {
        //     var relVal = params[0].name
        //     for (var i = 0, l = params.length; i < l; i++) {
        //       relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'V'
        //     }
        //     return relVal
        //   }
        // },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: {
          type: 'category',
          name: '周波数',
          data: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '1', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '2', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '3', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '4', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '5', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '6', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '7', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '8', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '9', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '10', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '11', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '12'],
          axisLabel: {
            show: true,
            interval: 0
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }
        ]
      },
      rfRmschart: {},
      // 电气量下拉框
      // countRmsSelectValue: 1,
      transientRmsData: {}
    }
  },
  computed: {
    // countRmsSelectOptions () {
    //   var countSelectOption = []
    //   for (var i = 0; i < this.transientData.length; i++) {
    //     countSelectOption[i] = {
    //       value: i + 1,
    //       label: '记录' + (i + 1)
    //     }
    //   }
    //   return countSelectOption
    // },
    // getIndexTransientData () {
    //   return this.transientData[this.countSelectValue]
    // },
    // transientData () {
    //   return this.$store.state.transientData
    // }
  },
  watch: {
    // countSelectValue () {
    //   this.setChartOption()
    // },
    // async transientData () {
    //   await this.updateData()
    //   await this.setChartOption()
    // }
    beginTs () {
      if (this.$store.state.reqMode === 'uart') {
        this.updateData()
      }
    }
  },
  async mounted () {
    this.rfRmschart = this.$echarts.init(document.getElementById('rfRmsOptions'))
    // this.rfRmschart.setOption(this.rfRmsOption)
    // await this.updateData()
    // await this.setChartOption()
    if (this.$store.state.reqMode === 'udp') {
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.updateData()
        }, 300)
      }
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      let params = {
        'collection': 'meter_transient_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'tsBegin': this.beginTs,
        'tsEnd': this.beginTs,
        'time': this.time,
        'fields': ['sag_ware_a', 'sag_ware_b', 'sag_ware_c'],
        'transpose': false
      }
      let data = await this.$api.queryTsData(params)
      this.transientRmsData = data.data.data
      // console.log(data.data.data)
      this.setChartOption()
    },
    setChartOption () {
      var max = 0
      var min = 0x7fffffff

      for (let i = 0; i < this.transientRmsData[0].sag_ware_a.length; i++) {
        if (max < this.transientRmsData[0].sag_ware_a[i]) max = this.transientRmsData[0].sag_ware_a[i]
        if (max < this.transientRmsData[0].sag_ware_b[i]) max = this.transientRmsData[0].sag_ware_b[i]
        if (max < this.transientRmsData[0].sag_ware_c[i]) max = this.transientRmsData[0].sag_ware_c[i]
        if (min > this.transientRmsData[0].sag_ware_a[i]) min = this.transientRmsData[0].sag_ware_a[i]
        if (min > this.transientRmsData[0].sag_ware_b[i]) min = this.transientRmsData[0].sag_ware_b[i]
        if (min > this.transientRmsData[0].sag_ware_c[i]) min = this.transientRmsData[0].sag_ware_c[i]
      }

      if (max > 1000 || min < -1000) {
        for (let i = 0; i < this.transientRmsData[0].sag_ware_a.length; i++) {
          this.rfRmsOption.series[0].data[i] = this.transientRmsData[0].sag_ware_a[i] * 0.001
          this.rfRmsOption.series[1].data[i] = this.transientRmsData[0].sag_ware_b[i] * 0.001
          this.rfRmsOption.series[2].data[i] = this.transientRmsData[0].sag_ware_c[i] * 0.001
        }
        this.rfRmsOption.yAxis[0].name = 'kV'
      } else {
        this.rfRmsOption.series[0].data = this.transientRmsData[0].sag_ware_a
        this.rfRmsOption.series[1].data = this.transientRmsData[0].sag_ware_b
        this.rfRmsOption.series[2].data = this.transientRmsData[0].sag_ware_c

        this.rfRmsOption.yAxis[0].name = 'V'
      }
      this.rfRmschart.setOption(this.rfRmsOption)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">暂升暂降波形记录(序号{{countSelectValue + 1}})</div>

<!--      <div style="width: 100%; display: flex;">-->
<!--        <div-->
<!--          style="width: 40%; display: flex; align-items: center; margin-left: 20px;">-->
<!--          <div>暂降记录次数</div>-->
<!--          <div style="width: 120px; margin-left: 20px">-->
<!--            <el-select v-model="countRmsSelectValue" placeholder="请选择">-->
<!--              <el-option-->
<!--                v-for="item in countRmsSelectOptions"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="dataItem" style="height: 100px; margin-top: 10px; width: 90%">-->
<!--        <div class="dataTitle"-->
<!--             style="width: 100%; margin: 0 10px; border-bottom: 1px solid #c2c2c2; border-top: 1px solid #c2c2c2; font-weight: 600; color: black;">-->
<!--          <div class="ItemLvalue" style="width: 30%; border-right: 1px solid #c2c2c2">发生时刻</div>-->
<!--          <div class="ItemSvalue" style="width: 20%; border-right: 1px solid #c2c2c2">类型</div>-->
<!--          <div class="ItemSvalue" style="width: 20%; border-right: 1px solid #c2c2c2">-->
<!--            持续时间(ms)-->
<!--          </div>-->
<!--          <div class="ItemLvalue" style="width: 30%">-->
<!--            <div style="margin: 5px 0">暂降/暂升深度(pu)</div>-->
<!--            <div class="dataTitleItemLva">-->
<!--              <div>A</div>-->
<!--              <div>B</div>-->
<!--              <div>C</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="dataBody" style="width: 100%; margin: 0 10px; height: 60px; border-bottom: 1px solid #c2c2c2;">-->
<!--          <div class="ItemLvalue" style="width: 30%;">-->
<!--            <div>{{-->
<!--                getIndexTransientData ? getIndexTransientData.sag_time_year : 0-->
<!--              }}/{{-->
<!--                getIndexTransientData ? getIndexTransientData.sag_time_month : 0-->
<!--              }}/{{ getIndexTransientData ? getIndexTransientData.sag_time_day : 0 }}-->
<!--            </div>-->
<!--            <div>{{-->
<!--                getIndexTransientData ? getIndexTransientData.sag_time_hour : 0-->
<!--              }}:{{-->
<!--                getIndexTransientData ? getIndexTransientData.sag_time_min : 0-->
<!--              }}:{{ getIndexTransientData ? getIndexTransientData.sag_time_sec : 0 }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="ItemSvalue" style="width: 20%;">-->
<!--            <div :class="getIndexTransientData?((getIndexTransientData.sag_type>>2) & 1)===1?'lightStyle1':'lightStyle':'lightStyle'">-->
<!--              <div :class="getIndexTransientData?((getIndexTransientData.sag_type>>2) & 1)===1?'lightItemStyle1':'lightItemStyle':'lightStyle'">A</div>-->
<!--            </div>-->
<!--            <div :class="getIndexTransientData?((getIndexTransientData.sag_type>>1) & 1)===1?'lightStyle1':'lightStyle':'lightStyle'">-->
<!--              <div :class="getIndexTransientData?((getIndexTransientData.sag_type>>1) & 1)===1?'lightItemStyle1':'lightItemStyle':'lightStyle'">B</div>-->
<!--            </div>-->
<!--            <div :class="getIndexTransientData?(getIndexTransientData.sag_type & 1)===1?'lightStyle1':'lightStyle':'lightStyle'">-->
<!--              <div :class="getIndexTransientData?(getIndexTransientData.sag_type & 1)===1?'lightItemStyle1':'lightItemStyle':'lightStyle'">C</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="ItemSvalue" style="width: 20%;">-->
<!--            <div>{{-->
<!--                getIndexTransientData ? getIndexTransientData.sag_cont_time_s * 1000 + getIndexTransientData.sag_cont_time_ms : 0-->
<!--              }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="ItemLvalue" style="width: 30%;">-->
<!--            <div class="dataTitleItemLva">-->
<!--              <div>{{ getIndexTransientData ? getIndexTransientData.sag_deptha.toFixed(3) : 0 }}</div>-->
<!--              <div>{{ getIndexTransientData ? getIndexTransientData.sag_depthb.toFixed(3) : 0 }}</div>-->
<!--              <div>{{ getIndexTransientData ? getIndexTransientData.sag_depthc.toFixed(3) : 0 }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div style="height: calc(100% - 50px);">
        <div id="rfRmsOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";
.pg{
  width: 100%;
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Transient/RfRmsChart/RfRmsChart.vue